export default __webpack_public_path__ + "static/media/inspiron1.a90d2881.webp";